import React  from "react";
import { useParams } from 'react-router-dom';
import AnimalInventoryForm from "../components/AnimalInventoryForm";
import { ANIMAL_TYPE_CATTLE } from "variables/constants";

const EditCattle = () => {
	const { cattleId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<AnimalInventoryForm recordId={cattleId ?? 0} mode="edit" animalTypeId={ANIMAL_TYPE_CATTLE}/>
	      </div>
	    </div>
    );
};

export default EditCattle;